import { SCREEN } from '../../utils/constants';

import { isValidFullName } from '../actions/fullNameActions';
import {navigate } from './movePages';
import { setFullName } from '../../utils/variables';

export function fullNameListeners() {
    /* on select fullName*/

    validateName();

    const fullNameElement = document.querySelector('.fullNames__container .fullName');
    if (fullNameElement) {
      fullNameElement.addEventListener('click', (e) => {
        const fullNameInput = document.getElementById('fullName');
        if (fullNameInput) {
          fullNameInput.focus();
        }

        e.preventDefault();
        let error = false;
        let input = document.querySelector('.fullName--input');

        if (
          !input.value ||
          (input.getAttribute('id') === 'fullName' &&
              !isValidFullName(input.value))
        ) {
            input.classList.add('invalid');
            error = true;
        }
        if (error) {
          return;
        }
      });
    }

    /* On click enter */
    const screenFullName = document
        .querySelector('.screen--fullName');

    if (screenFullName) {
        screenFullName.addEventListener('keydown', (event) => {
            if (event.key === 'Enter' && !document
            .querySelector('.fullNameContinue__btn').classList.contains('disabled')) {
                document
                    .querySelector('.fullNameContinue__btn').click();
            }
        });
    }

    /* on click Continue after select fullName */
    document
        .querySelector('.fullNameContinue__btn')
        .addEventListener('click', async () => {
          navigate(SCREEN.EMAIL);
          setTimeout(() => {
            const emailInput = document.getElementById('email');
            if (emailInput !== document.activeElement) {
              emailInput.focus();
            }
          }, 500);
        });
}

function validateName() {
  const name = document.querySelector('#fullName');
  const nameWrap = document.querySelector('.fullName');
  const invalidIcon = document.querySelector('.fullName__invalid');
  const validIcon = document.querySelector('.fullName__valid');
  name.oninput = (e) => {
      setFullName(e.target.value);
      if (isValidFullName(e.target.value)) {
          nameWrap.classList.add('valid');
          nameWrap.classList.remove('invalid');
          invalidIcon.classList.add('hidden');
          validIcon.classList.remove('hidden');
          name.classList.remove('invalid');
          document
            .querySelector('.fullNameContinue__btn')
            .classList.remove('disabled');
      } else {
          nameWrap.classList.remove('valid');
          nameWrap.classList.add('invalid');
          invalidIcon.classList.remove('hidden');
          document
            .querySelector('.fullNameContinue__btn')
            .classList.add('disabled');
      }
  };
}